var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubePlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55890",
    "data-name": "Group 55890",
    transform: "translate(-156.824 -1659.824)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 79,
    cy: 79,
    r: 79,
    transform: "translate(156.824 1659.824)",
    fill: "rgba(255, 255, 255, 0.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    transform: "translate(171.824 1674.824)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    stroke: "none",
    fill: "rgba(255, 255, 255, 0.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_87649",
    "data-name": "Path 87649",
    d: "M45.287,30.366,17.809,10.392a3.313,3.313,0,0,0-5.262,2.673V53a3.3,3.3,0,0,0,1.81,2.955,3.337,3.337,0,0,0,1.506.357,3.293,3.293,0,0,0,1.946-.643L45.287,35.712a3.287,3.287,0,0,0,0-5.346Z",
    transform: "translate(209.936 1705.79)",
    fill: "#444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubePlayButton);
export default __webpack_public_path__ + "static/media/youtubePlayButton.bf63988f5888b1e1b5ad51070f5f9120.svg";
export { ForwardRef as ReactComponent };